export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path fill="currentcolor" d="M6.959 3.27a.818.818 0 0 1 1.155-.06l8.716 7.844a1.273 1.273 0 0 1 0 1.892L8.114 20.79a.818.818 0 1 1-1.095-1.217L15.434 12 7.02 4.427a.82.82 0 0 1-.06-1.156Z"/>
</svg>
`;
